<template>
  <div class="flex gap-2 items-center">
    <ProjectName :project-hash="projectHash" />
    <div class="text-neutral-500 text-sm">/</div>
    <BoardName />
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { useStore } from 'vuex';
import ProjectName from './ProjectName.vue';
import BoardName from './BoardName.vue';

const store = useStore();

const projectHash = computed(() => store.getters['user/projects/getOpen']);
</script>
